<template>
  <v-layout justify-center>
         <v-flex xs12 >

         
    <v-card dark class="">
        <v-card-media class="white--text"    v-bind:class="{'largeScreenHeight' : getScreenWidth() > 900, 'smallScreenHeight' : getScreenWidth() < 900}" :src="artefact.mainImg[0].url">
            <div class="mainImg-overlay" style="">

            </div>
          <v-container fill-height fluid class="pr-1 pl-1">
            <v-layout fill-height column class="media">
              <!-- <v-flex xs12 align-start>
                <v-icon class="body-1 white--text">library_books</v-icon> <span class="body-1 white--text" v-for="items in artefact.collectionId" :key="items" > {{items}}</span>
              </v-flex> -->
                <v-card-actions>
                    <v-layout>
                        <v-icon dark>view_carousel</v-icon>
                    </v-layout>


                      <v-layout v-if="(isAdmin && toBeDeleted) || (isMod && toBeDeleted) "><v-spacer></v-spacer>
                        <v-btn flat icon @click="restoreArtefact"><v-icon dark  >replay</v-icon></v-btn>
                        <v-btn flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark  >edit</v-icon></v-btn>
                        <v-btn flat icon @click.native.stop="dialog = true" ><v-icon dark >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>Are you sure you want to delete this Artefact?</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">No</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >Yes</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>

                    
                    <v-layout v-else-if="isAdmin && isAccepted"><v-spacer></v-spacer>
                        <v-btn flat icon><v-icon dark >favorite_border</v-icon></v-btn>
                        <v-btn flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark>edit</v-icon></v-btn>
                        <v-btn flat icon @click.native.stop="dialog = true" ><v-icon dark >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>Are you sure you want to delete this Artefact?</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">No</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >Yes</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>
                    <v-layout v-else-if="(isAdmin && !isAccepted) || (isMod && !isAccepted) "><v-spacer></v-spacer>
                        <v-btn flat icon @click="acceptArtefact"><v-icon dark  >check_circle</v-icon></v-btn>
                        <v-btn flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark  >edit</v-icon></v-btn>
                        <v-btn flat icon @click.native.stop="dialog = true" ><v-icon dark >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>Are you sure you want to delete this Artefact?</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">No</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >Yes</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>



                    <v-layout v-else-if="!isAdmin && !isAccepted "><v-spacer></v-spacer></v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && isAuthor "><v-spacer></v-spacer>
                        <v-btn flat icon><v-icon dark >favorite_border</v-icon></v-btn>
                        <v-btn flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark>edit</v-icon></v-btn>
                        <v-btn flat icon @click.native.stop="dialog = true"><v-icon dark  >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>Are you sure you want to delete this Artefact?</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">No</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >Yes</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && !isAuthor && isLoggedIn "><v-spacer></v-spacer>
                        <v-btn flat icon><v-icon dark >favorite_border</v-icon></v-btn>
                    </v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && !isAuthor && !isLoggedIn "><v-spacer></v-spacer>
                    </v-layout>

                </v-card-actions>
                <v-card-title >
                    <v-layout >
                    <v-list-tile-content >
                        <div class="v-list-tile-content">
                        <v-list-tile-title class="display-1 v-list-tile-title" >{{artefact.title[lang].toUpperCase()}}</v-list-tile-title>
                        <v-list-tile-sub-title v-for="user in users" :key="user._id" v-if="user._id == artefact.userId " class="pb-2 pt-2 caption">{{gLang[lang].artefactSingle.addedBy}} {{user.displayName}} at {{artefact.meta.creationDate | date}} </v-list-tile-sub-title>
                        <hr width="100%">
                        <v-list-tile-sub-title class="pb-2 pt-2 caption" >
                            <v-layout row wrap>
                            
                               
                            <span v-for="(col,i) in  artefact.collectionId " :key="i" v-if="i<7" >&nbsp <v-icon left dark >label</v-icon> {{col}}</span>
                            <!-- <v-flex xs4><span><v-icon left dark >label</v-icon> {{artefact.collectionId[1]}}</span></v-flex> -->
                                
                            </v-layout>
                            </v-list-tile-sub-title>
                        </div>
                    </v-list-tile-content>
                    
                    </v-layout>
                </v-card-title>
            </v-layout>
          </v-container>
        </v-card-media>
    </v-card>


<v-card style="background-color:white" class="hidden-sm-and-down addBorder" flat>
          <v-card-text class="pr-0 pl-0">



  <div class="description pa-3">
      <p>{{artefact.description[lang]}}</p>
  </div>











<v-layout row wrap justify-center class="">
    <div class="div1"  v-for="media in artefact.uploads" :key="media._id">
        <v-flex xs12 sm12 v-if="media.type ==='image'"> 
            <div class=" position:relative"  >
                <img class="img1" :src="media.data[0].url" alt="">       
            </div>
        </v-flex>      
      <v-flex elevation-1 class="mt-3 mb-3" xs12 sm12 v-else-if="media.type === 'video'">
        <v-card>
         <div >
        <v-card-media>
      <div  class=""  >
        <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >  
      </div>
      </v-card-media> 
      </div>    
      </v-card>
      </v-flex>











    
      <v-flex elevation-1  v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mt-3 mb-3 img1' : true} " xs12  v-else-if="media.type === 'audio'">
            <div v-if="media.data.length != 0" class="">  
      <!-- <v-layout row style="width:100%; overflow:hidden; white-space:normal">

      <v-layout  class="">
      
      <div  class="" style="width:100%; overflow:hidden" >
        <a-player elevation-0 class="aplayer-style" style="width:100%; overflow:hidden"  :music="{
                            title: media.data[0].originalName,
                            author: ' ',
                            url: media.data[0].url,
                            pic: 'http://lectii-photoshop.com/wp-content/uploads/photo-shop/Lectii_Articole/Grafica%20pentru%20site/Music%20Icon/Music%20Icon-31.jpg',    
                            }">
        </a-player>
      </div>
      </v-layout>
      </v-layout> -->

      <v-layout justify-center>
          <v-flex xs12  >
              <v-layout row elevation-3 class="pa-1" style="background-color:#FAFAFA">
              
                    <div style="width:100%; background-color:#FAFAFA">
 <v-layout class="" row style="width:100%; white-space:normal; ">
                  <v-flex xs12>
                        <p> <i>{{media.data[0].originalName}}</i> </p>
                </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                    <audio controls style="width:100%; ">
                             <source :src="media.data[0].url" type="audio/ogg">
                            <source :src="media.data[0].url" type="audio/mpeg">
                                Your browser does not support the audio element.
                    </audio>
           </v-flex>
           
        

            </v-layout>
                </div>
                  
                
            </v-layout>
          </v-flex>
      </v-layout>

            
      
            
 
         </div>
       
      </v-flex>








      
      <v-flex elevation-3   v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mr-0  mt-2 mb-2  flex1' : true} "   xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">  
      <v-layout row wrap justify-center>

          <v-flex xs12   offset>
      <v-card style="box-shadow:none;">
          <v-list two-line>
              <v-list-tile >
            <v-list-tile-avatar >
              <v-icon class="blue white--text"> picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{media.data[0].originalName}}</v-list-tile-title>
              <v-list-tile-sub-title>{{artefact.meta.creationDate | date}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn :href="media.data[0].url" download icon ripple>
                <v-icon  color="grey lighten-1">file_download</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          </v-list>
      </v-card></v-flex>

      </v-layout>


          </div>
      </v-flex>


      
      <v-flex elevation-1 class="mt-2 mb-2 mr-1 ml-1 pt-1 pb-1" xs12 sm12 v-else-if="media.type === 'text'">


      
      
      <div  class="" >
        <div class="description pt-3 pl-3 pr-3 pb-0">
         <p v-html="media.value[lang]"></p>
       </div>
      </div>

      </v-flex>

      

   
       </div>

     
</v-layout>



      <v-speed-dial id="bottom_button" class="app-vue-speeddial"  v-if="!isAdmin && isLoggedIn"
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :hover="hover"
      :transition="transition"
      fixed
    >
      <v-btn class="ma-1"
        slot="activator"
        color="primary"
        dark
        fab
        hover
        v-model="fab"
        to='/artefacts/new'
      >
        <v-icon>add</v-icon>
        
      </v-btn>

    </v-speed-dial>






          </v-card-text>

    <web-location-present-single class="" :location="artefact.location"></web-location-present-single>
</v-card>


<web-location-tab :artefact="artefact"  :isCollection="false" class="hidden-md-and-up ">
   

  <div class="description pa-3">
      <p>{{artefact.description[lang]}}</p>
  </div>











<v-layout row wrap justify-center class="">
    <div class="div1"  v-for="media in artefact.uploads" :key="media._id">
        <v-flex xs12 sm12 v-if="media.type ==='image'"> 
            <div class=" position:relative"  >
                <img class="img1" :src="media.data[0].url" alt="">       
            </div>
        </v-flex>      
      <v-flex elevation-1 class="mt-3 mb-3" xs12 sm12 v-else-if="media.type === 'video'">
        <v-card>
         <div >
        <v-card-media>
      <div  class=""  >
        <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >  
      </div>
      </v-card-media> 
      </div>    
      </v-card>
      </v-flex>











    
      <v-flex elevation-1  v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mt-3 mb-3 img1' : true} " xs12 sm12 v-else-if="media.type === 'audio'">
            <div v-if="media.data.length != 0" class="ma-1 pa-3">  
      <!-- <v-layout row style="width:100%; overflow:hidden; white-space:normal">

      <v-layout  class="">
      
      <div  class="" style="width:100%; overflow:hidden" >
        <a-player elevation-0 class="aplayer-style" style="width:100%; overflow:hidden"  :music="{
                            title: media.data[0].originalName,
                            author: ' ',
                            url: media.data[0].url,
                            pic: 'http://lectii-photoshop.com/wp-content/uploads/photo-shop/Lectii_Articole/Grafica%20pentru%20site/Music%20Icon/Music%20Icon-31.jpg',    
                            }">
        </a-player>
      </div>
      </v-layout>
      </v-layout> -->

            <v-layout row elevation-3  v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'pa-1' : true} "  style="background-color:#FAFAFA">
                <div style="width:100%; background-color:#FAFAFA">
 <v-layout class="" row style="width:100%; white-space:normal; ">
                  <v-flex xs12>
                        <p> <i>{{media.data[0].originalName}}</i> </p>
                </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                    <audio controls style="width:100%; ">
                             <source :src="media.data[0].url" type="audio/ogg">
                            <source :src="media.data[0].url" type="audio/mpeg">
                                Your browser does not support the audio element.
                    </audio>
           </v-flex>
           
        

            </v-layout>
                </div>
            </v-layout>
      
            
 
         </div>
       
      </v-flex>








      
      <v-flex elevation-3 class="mr-0  mt-2 mb-2  flex1"  xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">  
      <v-layout row wrap justify-center>

          <v-flex xs12 sm10  offset>
      <v-card>
          <v-list two-line>
              <v-list-tile >
            <v-list-tile-avatar >
              <v-icon class="blue white--text"> picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{media.data[0].originalName}}</v-list-tile-title>
              <v-list-tile-sub-title>{{artefact.meta.creationDate | date}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn :href="media.data[0].url" download icon ripple>
                <v-icon  color="grey lighten-1">file_download</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          </v-list>
      </v-card></v-flex>

      </v-layout>


          </div>
      </v-flex>

      <v-flex elevation-3 class="mr-0 pl-3 pt-1 mt-2 mb-2 pb-1 flex1"  xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">  



      <!-- <v-layout row>

    

      <v-layout  class="">
      <div  class="pt-2 " style="width:100%"  >
        <v-layout row>
            <v-flex xs2>
        <v-btn small fab primary  :href="media.data[0].url" download><v-icon dark >picture_as_pdf</v-icon></v-btn>


            </v-flex>

            <v-flex xs10 style="position: relative;
    right: 5%;">
                <v-layout justify-center>
                    
            <a class="pdfText" > <b>{{media.data[0].originalName}}</b></a> <br>
                </v-layout>
                <v-layout justify-center>
                    
            <p class="pdfDate">{{artefact.meta.creationDate | date}}</p>
                </v-layout>

            </v-flex>
  
      </v-layout>
      </div>
      </v-layout>
      

      </v-layout> -->
    
          </div>

      </v-flex>

      
      <v-flex elevation-1 class="mt-2 mb-2 mr-1 ml-1 pt-1 pb-1" xs12 sm12 v-else-if="media.type === 'text'">


      
      
      <div  class="" >
        <div class="description pt-3 pl-3 pr-3 pb-0">
         <p v-html="media.value[lang]"></p>
       </div>
      </div>

      </v-flex>

      

   
       </div>

     
</v-layout>

         <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>


</web-location-tab> 

 
</v-flex>
     </v-layout>

</template>







<script>
import axios from "axios";
import VueAplayer from "vue-aplayer";
import VueDPlayer from "vue-dplayer";
export default {
  data() {
    return {
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      dialog: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      player: null,
      contextmenu: [
        {
          text: "Download Video",
          link: "https://github.com/MoePlayer/vue-dplayer"
        }
      ]
    };
  },
  mounted() {
    //this.player = this.$refs.player.dp
  },
  props: ["id"],

  methods: {
    //     moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }

    //   },
    imageClick: function(imageURL) {
      var modal = document.getElementById("myModal");
      var modalImg = document.getElementById("img01");
      modal.style.display = "block";
      modalImg.src = imageURL;
    },
    getScreenWidth() {
      return screen.width;
    },
    restoreArtefact(){
      this.$emit("artefactAccepted", this.artefact._id);
      this.artefact.deleted = false;
      this.$store.dispatch("updateArtefact", this.artefact);
      this.$router.push("/tasks");
    },
    acceptArtefact() {
      this.$emit("artefactAccepted", this.artefact._id);
      this.artefact.reviewed = true;
      this.$store.dispatch("updateArtefact", this.artefact);
      this.$router.push("/tasks");
    },
    deleteArtefact: function() {
      this.dialog = false;
      this.$emit("deletedArtefact");
      this.$store.dispatch("deleteArtefact", this.artefact);
      this.$router.push("/tasks");
      // axios.delete('http://localhost:3000/artefacts/'+this.id).then((response) => {
      //     this.$router.push("/artefacts");
      // },
      //     (err) => {
      //         console.log(err)
      //     })
    },
    // blabla(){
    //       this.$store.dispatch("loadArtefacts");
    //       this.onResize();
    // },
    spanClick: function() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    widthChange: function() {
      var img = document.getElementById("myImg");
      img.style.width = "100px";
    },
    handleSize() {
      var img = document.getElementsByClassName("myImg");

      var i = 0;
      for (i = 0; i < img.length; i++) {
        img[i].style.width = screen.width / 3.5 + "px";
        var height = img[i].style.width;
        img[i].style.height = height;
      }

      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    },
    handleVideoSize() {
      var video = document.getElementsByClassName("video");
      var videoContainer = document.getElementById("videoContainer");

      var i = 0;
      var sum = 0;
      for (i = 0; i < video.length; i++) {
        var x = video[i].style.width / video[i].style.height;
        video[i].style.height = screen.width * x + "px";
        sum = sum + video[i].style.height;
      }

      videoContainer.style.height = sum + "px";

      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    },
    play() {}
  },
  created() {
    if (this.artefact == undefined) this.$store.dispatch("loadArtefacts");
    this.artefact.visited++;
    this.$store.dispatch("updateArtefact", this.artefact);
  },
  mounted() {
    //  this.moveButton(this.isAdmin);
  },
  updated: function() {
    this.handleSize();
  },
  computed: {
    users() {
        return this.$store.getters.loadUsers;
    },
    toBeDeleted(){
      return this.artefact.deleted
    },
    isAccepted() {
      return this.artefact.reviewed;
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    artefact() {
      return this.$store.getters.loadArtefactSingle(this.id);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAccepted() {
      return this.artefact.reviewed;
    },
    isAuthor() {
      return this.artefact.userId == this.user._id;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  components: {
    "a-player": VueAplayer,
    "d-player": VueDPlayer
  }
};
</script>




<style scoped>
.mainImg-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
}

#myImg,
#myImg2,
#myImg3,
#myImg4,
#myImg5,
#myImg6 {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover,
#myImg2:hover,
#myImg3:hover,
#myImg4:hover,
#myImg5:hover,
#myImg6:hover {
  opacity: 0.7;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Caption of Modal Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  left: -27px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  background-color: transparent;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

.icon-circle {
  border-radius: 32px;
}

.pdfText {
  text-decoration: none;
  color: black !important;
  outline: none;
}

.pdfDate {
  font-size: 0.8em;
  color: grey;
}

.uploadedFilesText {
  color: grey;
}

.headerIcons {
  position: absolute;
  top: 6%;
  right: 4%;
}

.description p {
  text-align: justify;
}

.v-list-tile-content {
  position: absolute;
  bottom: 12%;
  width: 85%;
}

.v-list-tile-title {
  height: auto;
  white-space: normal;
  overflow: visible;
}

.div1 {
  position: relative;
  width: 100%;
}

.img1 {
  width: 100%;
}

.aplayer-style {
  box-shadow: 0 0 0 0;
}

.flex1 {
  position: relative;
  width: 100%;
}

.smallScreenHeight {
  height: 80vh !important;
}

.largeScreenHeight {
  height: 55vh !important;
}

.noBoxShadow {
  box-shadow: none !important;
}

.addBorder {
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ArtefactPreview.vue